'use client'

export const CTA = () => {
  return (
    <section
      className="w-full py-4 lg:py-8 px-4 lg:px-[320px]"
      style={{
        backgroundColor: '#006D93',
      }}
    >
      <div className="max-w-[1440px] mx-auto">
        {/* タイトルエリア */}
        <div className="flex flex-col gap-2 mb-2 lg:mb-4 text-center">
          <h2
            className="text-base lg:text-2xl lg:font-[Hiragino_Kaku_Gothic_Std,Hiragino_Kaku_Gothic_Pro,Meiryo,Yu_Gothic,sans-serif]"
            style={{
              fontWeight: 700,
              letterSpacing: '0.64px',
              lineHeight: '1.5',
              color: '#FFFFFF',
              textShadow: '0px 0px 8px rgba(0, 0, 0, 0.25)',
            }}
          >
            今すぐ簡単にご利用可能！
          </h2>
          <div
            className="text-xs lg:text-base"
            style={{
              fontWeight: 500,
              letterSpacing: '0.48px',
              lineHeight: '1.5',
              color: '#FFFFFF',
              textShadow: '0px 0px 8px rgba(0, 0, 0, 0.25)',
            }}
          >
            <p style={{ marginBottom: 0 }}>ギフトモールならWEB完結即時発注可能！</p>
            <p style={{ margin: 0 }}>お客様へのお渡し方法も簡単！</p>
          </div>
        </div>

        {/* ボタンエリア */}
        <div className="flex flex-col lg:flex-row gap-2 lg:gap-[10px] lg:justify-center">
          {/* お問い合わせボタン（ピンク） */}
          <button
            type="button"
            className="flex-1 lg:flex-none lg:w-[380px] flex items-center justify-center transition-all duration-200 px-2 lg:px-6 py-2 lg:py-3 rounded-lg active:bg-[#C1326A]"
            style={{
              backgroundColor: '#DA3B78',
              boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
              gap: '4px',
              border: 'none',
              cursor: 'pointer',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#C1326A'
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = '#DA3B78'
            }}
            onTouchStart={e => {
              e.currentTarget.style.backgroundColor = '#C1326A'
            }}
            onTouchEnd={e => {
              e.currentTarget.style.backgroundColor = '#DA3B78'
            }}
            onClick={() => {
              const contactSection = document.getElementById('contact')
              if (contactSection) {
                window.history.pushState(null, '', '/?form=consultation')
                contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' })
              }
            }}
          >
            <div className="hidden lg:block" style={{ width: '24px' }} />
            <div className="flex flex-col items-center gap-[2px]" style={{ flex: 1 }}>
              <span
                className="text-[10px] lg:text-xs lg:font-[Hiragino_Kaku_Gothic_Pro,Meiryo,Yu_Gothic,sans-serif]"
                style={{
                  fontWeight: 600,
                  letterSpacing: '0.4px',
                  lineHeight: '1.5',
                  color: '#FFFFFF',
                }}
              >
                サービスのより詳しい説明はこちら
              </span>
              <span
                className="text-sm lg:text-base lg:font-[Hiragino_Kaku_Gothic_Pro,Meiryo,Yu_Gothic,sans-serif]"
                style={{
                  fontWeight: 600,
                  letterSpacing: '0.56px',
                  lineHeight: '1.5',
                  color: '#FFFFFF',
                }}
              >
                お問い合わせ・資料請求
              </span>
            </div>
            <svg
              className="w-6 h-6 lg:w-6 lg:h-6"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <title>矢印アイコン</title>
              <path d="M9 5L16 12L9 19" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>

          {/* 無料アカウント登録ボタン（白） */}
          <a
            href="https://web.catalog.giftmall.co.jp/signup"
            className="flex-1 lg:flex-none lg:w-[380px] flex items-center justify-center transition-all duration-200 px-2 lg:px-6 py-2 lg:py-3 rounded-lg active:bg-[#FFF5F9]"
            style={{
              backgroundColor: '#FFFFFF',
              boxShadow: '0px 0px 4px 0px rgba(0, 0, 0, 0.25)',
              gap: '4px',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.backgroundColor = '#FFF5F9'
            }}
            onMouseLeave={e => {
              e.currentTarget.style.backgroundColor = '#FFFFFF'
            }}
            onTouchStart={e => {
              e.currentTarget.style.backgroundColor = '#FFF5F9'
            }}
            onTouchEnd={e => {
              e.currentTarget.style.backgroundColor = '#FFFFFF'
            }}
          >
            <div className="hidden lg:block" style={{ width: '24px' }} />
            <div className="flex flex-col items-center gap-[2px]" style={{ flex: 1 }}>
              <span
                className="text-[10px] lg:text-xs lg:font-[Hiragino_Kaku_Gothic_Pro,Meiryo,Yu_Gothic,sans-serif]"
                style={{
                  fontWeight: 600,
                  letterSpacing: '0.4px',
                  lineHeight: '1.5',
                  color: '#DA3B78',
                }}
              >
                WEB完結で即時発注も可能
              </span>
              <span
                className="text-base lg:text-base lg:font-[Hiragino_Kaku_Gothic_Pro,Meiryo,Yu_Gothic,sans-serif]"
                style={{
                  fontWeight: 600,
                  letterSpacing: '0.64px',
                  lineHeight: '1.5',
                  color: '#DA3B78',
                }}
              >
                無料アカウント登録
              </span>
            </div>
            <svg
              className="w-[18px] h-[18px] lg:w-6 lg:h-6"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <title>矢印アイコン</title>
              <path d="M9 5L16 12L9 19" stroke="#DA3B78" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
        </div>
      </div>
    </section>
  )
}
